const catalogPaginationPerPageOptions = [
  { title: '10', value: 10 },
  { title: '20', value: 20 },
  { title: '30', value: 30 },
];

export default catalogPaginationPerPageOptions;
